import fetch from 'isomorphic-fetch';
import React from 'react';

/**
 * React
 */
class ProductRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    let name = this.props.product.stocked ? 
      this.props.product.name : 
      <span style={{color: 'red'}}>
        {this.props.product.name}
      </span>;
    return (
      <tr>
        <td>{this.props.product.category}</td>
        <td>{name}</td>
        <td>{this.props.product.price}</td>
        <td>{this.props.product.qty}</td>
      </tr>
    );
  }
}

class ProductTable extends React.Component {
  render() {
    var rows = [];
    this.props.products.forEach((product) => {
      if (product.name.toLowerCase().indexOf(this.props.filterText) === -1 || (!product.stocked && this.props.inStockOnly)) {
        return;
      }
      rows.push(<ProductRow product={product} key={product.name} />); 
    });

    return (
      <table>
        <thead>
          <tr>
            <th>类别</th>
            <th>名称</th>
            <th>单价</th>
            <th>数量</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}

class SearchBar extends React.Component {
  constructor(props) { 
    super(props); 
    this.state = {inStockOnly: true};
    this.handleFilterTextInputChange = this.handleFilterTextInputChange.bind(this); 
    this.handleInStockInputChange = this.handleInStockInputChange.bind(this); 
    this.handleSubmit = this.handleSubmit.bind(this); 
  }

  handleFilterTextInputChange(e) { 
    e.preventDefault();
    this.props.onFilterTextInput(e.target.value); 
  }
    
  handleInStockInputChange(e) { 
    e.preventDefault();
    this.props.onInStockInput(e.target.checked); 
    this.setState(prevState => ({ 
      inStockOnly: !prevState.inStockOnly 
    })); 
  }

   handleSubmit(e) { 
    e.preventDefault();
   }

  render() {
    return (
      <form
        onSubmit={this.handleSubmit}
      >
        <input 
          type="text" 
          placeholder="输入要查找的关键字..." 
          value={this.props.filterText} 
          onChange={this.handleFilterTextInputChange}
        />
        <p>
          <input 
            type="checkbox" 
            checked={this.state.inStockOnly} 
            onChange={this.handleInStockInputChange}
          />
          {' '}
          仅显示有库存商品
        </p>
      </form>
    );
  }
}

class FilterableProductTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterText: '',
      inStockOnly: false
    };
    this.handleFilterTextInput = this.handleFilterTextInput.bind(this); 
    this.handleInStockInput = this.handleInStockInput.bind(this); 
  }

  handleFilterTextInput(filterText) { 
    this.setState({ filterText: filterText }); 
  }
       
  handleInStockInput(inStockOnly) { 
    this.setState({ inStockOnly: inStockOnly }) 
  }

  render(){
    return (
      <div>
        <SearchBar 
          filterText={this.state.filterText}
          inStockOnly={this.state.inStockOnly}
          onFilterTextInput={this.handleFilterTextInput} 
          onInStockInput={this.handleInStockInput}
        />
        <ProductTable 
          products={this.props.products} 
          filterText={this.state.filterText.toLowerCase()}
          inStockOnly={this.state.inStockOnly}
        />
      </div>
    );
  }
}

class FilterableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [{
        "category": "", 
        "price": "", 
        "stocked": true, 
        "name": ""
      }]
    }
  }
  componentDidMount() {
    fetch('/api/cache/stock.json') 
      .then(response => response.json()) 
      .then(json => this.setState({
        products: json 
      })); 

  }

  render() {
    return (
      <FilterableProductTable products={this.state.products} />
    )
  }
}

export default FilterableTable;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/FilterableTable.js